import { InactivityTimeoutWrapper } from '../../containers/inactivity-timeout-wrapper/inactivity-timeout-wrapper.component';
import CaptureImage from './capture-image.component';

export default function CaptureImagePage() {
  return (
    <InactivityTimeoutWrapper>
      <CaptureImage />
    </InactivityTimeoutWrapper>
  );
}
